import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { loadConfig, loadDeskeraSyncedProducts } from "src/redux/actions/square";
import Alert from "src/components/Alert";
import SyncStatus from "src/components/SyncStatus";
import getSymbolFromCurrency from "currency-symbol-map";
import { syncDeskeraProductsToSquare } from "src/api";
import RowSelectionTable from "src/components/RowSelectionTable";


function DeskeraProducts() {
  const [syncStatus, setSyncStatus] = useState("enabled");
  const products = useSelector((state) => state.square.deskeraproducts);
  const dispatch = useDispatch();
  const [pageCount, setPageCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [status, setStatus] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  

  useEffect(() => {
    dispatch(loadConfig());
    dispatch(loadDeskeraSyncedProducts());
  }, []);


  const data = useMemo(() => products.data, [products]);

  const columns = useMemo(
    () => [
      {
        Header: "Product Code",
        accessor: "deskeraDocumentCode",
      },
      {
        Header: "Name",
        accessor: "productName",
        Cell: ({ cell: { row } }) => (
          <span>
          {row.original.productName} {row.original.productVariantName && row.original.productVariantName !== "Default Title" && "(" + row.original.productVariantName + ")"}
          </span>
        ),
      },
      {
        Header: "Description",
        accessor: "description",
      },
      {
        Header: "Unit Price",
        accessor: "productUnitPrice",
        Cell: ({ cell: {row} }) => (
          <span>
            {getSymbolFromCurrency(row.original.currency)}{" "}
            {row.original.productUnitPrice}
          </span>
        ),
        className: "text-right",
      },
      {
        Header: "Sync Status",
        accessor: "syncStatus",
        Cell: ({ cell: { row } }) => {
          return <SyncStatus status={row.original.syncStatus} reason={row.original.reason} />;
        },
        disableGlobalFilter: true,
      },
    ],
    []
  );

  const config = useSelector((state) => state.square.config);

  useEffect(() => {
    setLoading(false);
    if(data && data.totalPages) {
      setPageCount(data.totalPages);
    }
  }, [data]);

  const refreshData = ({ pageSize, pageIndex, status}) => {
    setPageSize(pageSize);
    setPageIndex(pageIndex);
    setStatus(status);
    setLoading(true);
    dispatch(loadDeskeraSyncedProducts(pageSize, pageIndex, status));
  }; 

  return (
    <div className="p-4">
      <h3 className="mb-3">Deskera Products</h3>
      {(!config.data || !config.data.syncEnabled) && (
        <Alert type="warning">
          Your Deskera Products will appear here. Please complete{" "}
          <Link to="/app/square" className="text-alert-warning">
            <u>Setup</u>
          </Link>{" "}
          before continuing.
        </Alert>
      )}
      <RowSelectionTable data={data.content ? data.content : []} columns={columns} migrate={syncDeskeraProductsToSquare} cart='square'
      refresh={refreshData} pageCount={pageCount} loading={loading}  />
    </div>
  );
}

export default DeskeraProducts;
